import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { apiGet } from "../../api/client";
import { useAuth } from "../../auth/AuthContext";
import type { RosterEntry } from "../../types";

export function TutorRosterPage() {
  const { user } = useAuth();
  // An admin reaching this page sees every learner, not a cohort of their own.
  const scope = user?.role === "admin" ? "on the platform" : "in your cohort";

  const { data, isLoading } = useQuery({
    queryKey: ["tutor-roster"],
    queryFn: () => apiGet<RosterEntry[]>("/api/tutor/learners"),
  });

  if (isLoading) return <p className="text-muted">Loading roster...</p>;
  if (!data || data.length === 0) return <p className="text-muted">No learners {scope} yet.</p>;

  return (
    <div className="tutor-roster">
      <h1>Learner Roster</h1>
      <p className="text-muted">{data.length} learners {scope}</p>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Student no.</th>
              <th>Name</th>
              <th>Curriculum</th>
              <th>Mastery</th>
              <th>Completion</th>
              <th>Attempts</th>
              <th>Trend</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map((l) => (
              <tr key={l.id} className={l.needs_intervention ? "row-alert" : ""}>
                {/* First column: it is the identifier a teacher reads out,
                    and the reason it exists is two learners with one name. */}
                <td>
                  <span className="student-number">
                    {l.student_number ?? "—"}
                  </span>
                </td>
                <td><strong>{l.name}</strong></td>
                <td>{l.curriculum}</td>
                <td>
                  <span className={l.mastery >= 70 ? "text-success" : l.mastery >= 50 ? "text-warning" : "text-danger"}>
                    {l.mastery}%
                  </span>
                </td>
                <td>{l.completion}%</td>
                <td>{l.attempts}</td>
                <td>{l.trend === "improving" ? "📈" : l.trend === "declining" ? "📉" : l.trend === "new" ? "🆕" : "➡️"}</td>
                <td>
                  {l.needs_intervention
                    ? <span className="badge badge-danger">⚠️ At Risk</span>
                    : <span className="badge">On Track</span>}
                </td>
                <td>
                  <Link to={`/tutor/learners/${l.id}`} className="btn btn-sm btn-secondary">
                    View →
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
